"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateArticlePosition = exports.calculateArticlesToShow = void 0;
var ArticleBase_1 = require("../../molecules/Article/ArticleBase");
/**
 * Calculate the number of articles to show based on the width of the bar
 */
var calculateArticlesToShow = function (barWidth) {
    // If the width is too small show no articles
    if (barWidth < ArticleBase_1.articleDefaultWidth) {
        return 0;
    }
    var endArticlesWidth = (ArticleBase_1.articleReducedWidth * 2) - ArticleBase_1.articleOverlap;
    // If the width is less than two end articles show two
    if (barWidth < endArticlesWidth) {
        return 2;
    }
    // Otherwise divide the remaining space and calculate how many we can show in addition to the articles on each end
    return 2 + Math.floor((barWidth - endArticlesWidth) / (ArticleBase_1.articleDefaultWidth - ArticleBase_1.articleOverlap));
};
exports.calculateArticlesToShow = calculateArticlesToShow;
/**
 * Ensure the first and last article that is shown have the appropriate shape adjustments
 * @param articleIndex the index of the article
 * @param articlesToShow the number of articles we can show
 */
var calculateArticlePosition = function (articleIndex, articlesToShow) {
    // If we are only showing one article it must be the MIDDLE style regardless of it's position
    if (articlesToShow === 1) {
        return ArticleBase_1.ArticlePosition.MIDDLE;
    }
    // The first article must be START style
    if (articleIndex === 0) {
        return ArticleBase_1.ArticlePosition.START;
    }
    // The last article must but be END style
    if ((articleIndex + 1) >= articlesToShow) {
        return ArticleBase_1.ArticlePosition.END;
    }
    // Everything else must be MIDDLE style
    return ArticleBase_1.ArticlePosition.MIDDLE;
};
exports.calculateArticlePosition = calculateArticlePosition;
